module.exports = __webpack_public_path__ + "static/InputField_checkbox-13736450d32f5a99f98b81362d469973.png";